import axios from "axios";
import SideBar from "./sidebar/ManagerSideBar";
import DashBoardNavbar from "./navbar/DashBoardNavbar";
// export default ProjectDetails;
import * as React from 'react';
import { styled } from '@mui/system';
import TablePagination, {
  tablePaginationClasses as classes,
} from '@mui/base/TablePagination';
import { useNavigate } from 'react-router';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";


function ChangeLogs() {
  const [user, setuser] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [rows1, setRows1] = React.useState([]);


  let navigate = useNavigate();
  const userType = sessionStorage.getItem('role') == 'Admin'

  const getData = () => {
    let data = axios.get('/api/logs/changelogs', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        setRows(response.data.reverse())
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });

  }
  const getData1 = () => {
    let data = axios.get('/api/logs/jsonlogs', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        setRows1(response.data.reverse())
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });

  }


  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    showSuccessToast(`Rows Per Page changed to ${parseInt(event.target.value, 10)}`)
  };

  //for json logs
  const [page1, setPage1] = React.useState(0);
  const [rowsPerPage1, setRowsPerPage1] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows1 =
    page1 > 0 ? Math.max(0, (1 + page1) * rowsPerPage1 - rows1.length) : 0;

  const handleChangePage1 = (event, newPage) => {
    setPage1(newPage);
  };

  const handleChangeRowsPerPage1 = (event) => {
    setRowsPerPage1(parseInt(event.target.value, 10));
    setPage1(0);
    showSuccessToast(`Rows Per Page changed to ${parseInt(event.target.value, 10)}`)
  };

  React.useEffect(() => {
    getData()
    getData1()
  }, [])
  const blue = {
    200: '#A5D8FF',
    400: '#3399FF',
  };

  const grey = {
    50: '#F3F6F9',
    100: '#E7EBF0',
    200: '#E0E3E7',
    300: '#CDD2D7',
    400: '#B2BAC2',
    500: '#A0AAB4',
    600: '#6F7E8C',
    700: '#3E5060',
    800: '#2D3843',
    900: '#1A2027',
  };

  const Root = styled('div')(
    ({ theme }) => `
    table {
      font-family: IBM Plex Sans, sans-serif;
      font-size: 0.875rem;
      border-collapse: collapse;
      width: 100%;
    }
  
    td,
    th {
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      text-align: left;
      padding: 6px;
    }
  
    th {
      background-color: ${theme.palette.mode === 'dark' ? grey[900] : grey[100]};
    }
    `,
  );

  const CustomTablePagination = styled(TablePagination)(
    ({ theme }) => `
    & .${classes.spacer} {
      display: none;
    }
  
    & .${classes.toolbar}  {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
  
      @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
      }
    }
  
    & .${classes.selectLabel} {
      margin: 0;
    }
  
    & .${classes.select}{
      padding: 2px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      border-radius: 50px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      }
    }
  
    & .${classes.displayedRows} {
      margin: 0;
  
      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
  
    & .${classes.actions} {
      padding: 2px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      border-radius: 50px;
      text-align: center;
    }
  
    & .${classes.actions} > button {
      margin: 0 8px;
      border: transparent;
      border-radius: 2px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      }
    }
    `,
  );

  const logOut = () => {
    sessionStorage.clear();
    // navigate('/login')
    navigate("../login", { replace: true });

  }

  const getBackgroundColor = (type) => {
    if (type.toLowerCase() === 'add(bulk)') {
      return '#FFD580	'
    }
    else if (type === 'add') {
      return 'lightblue';
    } else if (type === 'update') {
      return 'lightgreen';
    } else if (type === 'delete') {
      return '#FFC0CB';
    };
  }

  return (
    <body className="g-sidenav-show overflow-hidden bg-gray-200">
      {/* side navbar */}
      <SideBar logOut={logOut} />
      <main className="main-content position-relative h-100 border-radius-lg">

        <DashBoardNavbar user={user} />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-info shadow-info border-radius-lg pt-4 pb-3">
                    <h6 className="text-white text-capitalize ps-3">
                      Change Logs
                    </h6>
                  </div>
                </div>
                <div className="card-body px-4 pb-2">
                  <div className="table-responsive p-0 d-flex justify-content-center align-items-center">
                    <Root sx={{ width: 1500, maxWidth: '100%' }}>
                      <table aria-label="custom pagination table">
                        <thead>
                          <tr>
                            <th style={{ width: '100px' }}>Sr No.</th>
                            <th >User</th>
                            <th>Seller</th>
                            <th>TimeStamp</th>
                            <th style={{ textAlign: 'center' }}>Action</th>

                          </tr>
                        </thead>
                        <tbody>
                          {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                          ).map((row, index) => (
                            <tr key={row._id}>
                              <td>{index + 1}</td>

                              <td>{row.user ? row.user.username : "No user ID"}</td>
                              <td style={{ width: 240 }} align="right">
                                {row.seller ? row.seller.seller_id : "Deleted Seller"}
                              </td>
                              <td style={{ width: 240 }} align="right">
                                {row.timestamp ? new Date(row.timestamp).toLocaleString() : ""}
                              </td>
                              <td style={{ width: 240 }} align="right">
                                <p style={{
                                  backgroundColor: getBackgroundColor(row.action),
                                  width: '50%',
                                  padding: '5px',
                                  borderRadius: '10px',
                                  textAlign: 'center',
                                  margin: 'auto'
                                }}
                                >
                                  {/* {row.action.toLowerCase() ==='add(bulk)'?'Add(Bulk)': ""} */}
                                  {row.action ? row.action.charAt(0).toUpperCase() + row.action.slice(1).toLowerCase() : ""}

                                </p>
                              </td>
                            </tr>
                          ))}

                          {emptyRows > 0 && (
                            <tr style={{ height: 34 * emptyRows }}>
                              <td colSpan={3} />
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <CustomTablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                              colSpan={3}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              slotProps={{
                                select: {
                                  'aria-label': 'rows per page',
                                },
                                actions: {
                                  showFirstButton: true,
                                  showLastButton: true,
                                },
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </tr>
                        </tfoot>
                      </table>
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-info shadow-info border-radius-lg pt-4 pb-3">
                    <h6 className="text-white text-capitalize ps-3">
                      Json Logs
                    </h6>
                  </div>
                </div>
                <div className="card-body px-4 pb-2">
                  <div className="table-responsive p-0 d-flex justify-content-center align-items-center">
                    <Root sx={{ width: 1500, maxWidth: '100%' }}>
                      <table aria-label="custom pagination table">
                        <thead>
                          <tr>
                            <th style={{ width: '100px' }}>Sr No.</th>
                            <th >User</th>
                            <th >User Role</th>
                            <th>Comment</th>
                            <th>TimeStamp</th>

                          </tr>
                        </thead>
                        <tbody>
                          {(rowsPerPage1 > 0
                            ? rows1.slice(page1 * rowsPerPage1, page1 * rowsPerPage1 + rowsPerPage1)
                            : rows1
                          ).map((row, index) => (
                            <tr key={row._id}>
                              <td>{index + 1}</td>

                              <td>{row.user ? row.user.username : "No user ID"}</td>
                              <td>{row.user ? row.userRole : "No user role"}</td>

                              <td style={{ width: 240 }} align="right">
                                {row.comment ? row.comment : "No Comment"}
                              </td>
                              <td style={{ width: 240 }} align="right">
                                {row.timestamp ? new Date(row.timestamp).toLocaleString() : ""}
                              </td>

                            </tr>
                          ))}

                          {emptyRows1 > 0 && (
                            <tr style={{ height: 34 * emptyRows1 }}>
                              <td colSpan={3} />
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <CustomTablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                              colSpan={3}
                              count={rows1.length}
                              rowsPerPage={rowsPerPage1}
                              page={page}
                              slotProps={{
                                select: {
                                  'aria-label': 'rows per page',
                                },
                                actions: {
                                  showFirstButton: true,
                                  showLastButton: true,
                                },
                              }}
                              onPageChange={handleChangePage1}
                              onRowsPerPageChange={handleChangeRowsPerPage1}
                            />
                          </tr>
                        </tfoot>
                      </table>
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </body>
  );
}

export default ChangeLogs;






